import React, {useState} from "react";
import {useCurrentUser} from "../../../utils/CurrentUserContext";
import {CompanyType} from "../../../__generated__/graphql";

export default function TopStats({totalData}) {
  const {user} = useCurrentUser();

  const getStatsData = () => {
    const formatNumber = (num) => num ? num.toLocaleString() : '0';
    const formatPercentage = (num) => num ? `${num.toFixed(2)}%` : '0%';
    const formatCurrency = (num) => ({
      value: <><span className="text-xs">DKK</span> {num ? num.toFixed(2) : '0.00'}</>,
      className: ''
    });
    const formatSeconds = (num) => num ? `${num.toFixed(2)}s` : '0s';

    return [
      {name: "Total Impressions", total: formatNumber(totalData?.tdImpressions)},
      {name: "Reads", total: formatNumber(totalData?.reads)},
      {
        name: "CTR", total: totalData?.tdImpressions > 0 && totalData?.tdClicks
          ? formatPercentage((totalData.tdClicks / totalData.tdImpressions) * 100)
          : '-'
      },
      {name: "Click Outs", total: formatNumber(totalData?.clickOuts)},
      user.company.type === CompanyType.Publisher
        ? {name: "Revenue", total: formatCurrency(totalData?.publisherRevenue)}
        : {name: "Cost", total: formatCurrency(totalData?.totalCost)},
      {name: "Avr. Read Time", total: formatSeconds(totalData?.avgReadtime)},
      user.company.type === CompanyType.Publisher
        ? {name: "eCPM", total: formatCurrency(totalData?.eCpm)}
        : {
          name: "eCPM", total: totalData?.tdImpressions > 0 && totalData?.totalCost
            ? formatCurrency(totalData.totalCost / (totalData.tdImpressions / 1000))
            : '-'
        },
    ];
  };

  return (
    <div>
      <dl
        className="grid grid-cols-1 divide-y divide-gray-200 overflow-hidden rounded-lg bg-white shadow md:grid-cols-7 md:divide-y-0 md:divide-x">
        {getStatsData().map((item, index) => (
          <div key={index} className="px-4 py-5 sm:p-6">
            <dt className="text-sm font-semibold text-gray-900">
              {item.name}
            </dt>
            <dd className="sm:px-6 w-full mb-2">
              <div className={`flex items-baseline text-2xl font-semibold text-indigo-600 justify-end ${item.total.className || ''}`}>
                {typeof item.total === 'string' ? item.total : item.total.value}
              </div>
            </dd>
          </div>
        ))}
      </dl>
    </div>
  );
}
